import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Checkbox,
  Grid,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  CmpButton,
  CmpSelectBox,
  CmpSelectField,
  CmpTypographyField,
  CmpTypographyNew,
} from "../ToolBox/ToolBox";
import {
  INV05_StockSetupGetrow_Api,
  INV05_StockSetupUpdate_Api,
  StockSetupReason_GETROW,
  VNDRDISB_Barcode_List_Getrow,
} from "../../../Server/ApiV2";
import { fAlertToast, fKeyTabInput } from "../../../Utility/Utilitys";
import { useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";

export default function GCStockSetupChangeReq({
  open,
  handleClose,
  ItemCd,
  ItemName,
  vendorCd,
  vendorName,
  loc,
  vRdxuserLoc,
}) {
  const vMediaQuery = useMediaQuery("(max-width:850px)");
  const xMediaQuery = useMediaQuery("(max-width:450px)");
  const aMediaQuery = useMediaQuery("(max-width:1200px)");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: vMediaQuery ? "95%" : aMediaQuery ? "80%" : 900,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 2,
  };
  const vRdxUserCd = useSelector((state) => state.login.value);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const [barcode, setBarcode] = useState([]);
  const [disReason, setDisReason] = useState([]);
  const [activeReason, setActiveReason] = useState([]);
  const [dcDisconReason, setDcDisconReason] = useState([]);
  const [cNTLPurchaseReason, setCNTLReason] = useState([]);
  const [localPurReason, setLocalPurReason] = useState([]);
  const [vendorDisReason, setVendorDisPurReason] = useState([]);
  const [listedReason, setListedReason] = useState([]);
  const [stockDaysReason, setStockDaysReason] = useState([]);
  const [shelfQtyReason, setShelfQtyReason] = useState([]);
  const [moqReason, setMOQReason] = useState([]);

  const [locationName, setLocationName] = useState("");
  // Define your initial state
  const initialFormData = {
    vendorDiscontinueOld: false,
    vendorDiscontinueNew: false,
    flagVendorDiscontinue: 0,
    dcDiscontinueOld: false,
    dcDiscontinueNew: false,
    flagDCDiscontinue: 0,
    controlPurchaseOld: false,
    controlPurchaseNew: false,
    flagControlPurchase: 0,
    isActiveOld: false,
    isActiveNew: false,
    flagActive: 0,
    minStockDaysOld: 0,
    minStockDaysNew: 0,
    flagMinStockDays: 0,
    maxStockDaysOld: 0,
    maxStockDaysNew: 0,
    flagMaxStockDays: 0,
    safetyStockDaysOld: 0,
    safetyStockDaysNew: 0,
    flagSafetyStockDays: 0,
    maxShelfQtyOld: 0,
    maxShelfQtyNew: 0,
    flagMaxShelfQty: 0,
    minShelfQtyOld: 0,
    minShelfQtyNew: 0,
    flagMinShelfQty: 0,
    localPurchaseOld: false,
    localPurchaseNew: false,
    flagLocalPurchase: 0,
    discontinueOld: false,
    discontinueNew: false,
    flagDiscontinue: 0,
    listingOld: false,
    listingNew: false,
    flagListing: 0,
    moqOld: 0,
    moqNew: 0,
    flagMoq: 0,
    Barcode: barcode[0]?.Cd || "All",
    //reason
    VendorReason: vendorDisReason[0]?.UID,
    DisContinuedReason: disReason[0]?.UID,
    LCLPurReason: localPurReason[0]?.UID,
    CNTRLPURReason: cNTLPurchaseReason[0]?.UID,
    dcDiscontinueReason: dcDisconReason[0]?.UID,
    ActiveReason: activeReason[0]?.UID,
    ListingReason: listedReason[0]?.UID,
    MoqReason: moqReason[0]?.UID,
    shelfqtyreason: shelfQtyReason[0]?.UID,
    stockdaysreason: stockDaysReason[0]?.UID,
  };
  const [formData, setFormData] = useState(initialFormData);

  let initialError = {
    VendorReason: "",
    DisContinuedReason: "",
    LCLPurReason: "",
    CNTRLPURReason: "",
    dcDiscontinueReason: "",
    ActiveReason: "",
    ListingReason: "",
    MoqReason: "",
    shelfqtyreason: "",
    stockdaysreason: "",
  };
  const [errors, setErrors] = useState(initialError);

  const fValidation = () => {
    let isValid = true;
    const newError = { initialError };
    if (
      formData?.discontinueNew &&
      vRdxUserCd?.UserGroupCode === "01" &&
      formData?.flagDiscontinue === 0 &&
      (formData?.DisContinuedReason == "" ||
        formData?.DisContinuedReason == undefined ||
        formData?.DisContinuedReason === null)
    ) {
      newError.DisContinuedReason = "DisContinuedReason is required.";
      isValid = false;
    }

    if (
      formData?.vendorDiscontinueNew &&
      vRdxUserCd?.UserGroupCode === "01" &&
      formData?.flagVendorDiscontinue === 0 &&
      (formData?.VendorReason == "" ||
        formData?.VendorReason == undefined ||
        formData?.VendorReason === null)
    ) {
      newError.VendorReason = "VendorReason is required.";
      isValid = false;
    }
    if (
      formData?.isActiveNew &&
      vRdxUserCd?.UserGroupCode === "01" &&
      formData?.flagActive === 0 &&
      (formData?.ActiveReason == "" ||
        formData?.ActiveReason == undefined ||
        formData?.ActiveReason === null)
    ) {
      newError.ActiveReason = "ActiveReason is required.";
      isValid = false;
    }

    if (
      formData?.dcDiscontinueNew &&
      vRdxUserCd?.UserGroupCode === "01" &&
      formData?.flagDCDiscontinue === 0 &&
      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val !== "N" &&
      (formData?.dcDiscontinueReason == "" ||
        formData?.dcDiscontinueReason == undefined ||
        formData?.dcDiscontinueReason === null)
    ) {
      newError.dcDiscontinueReason = "dcDiscontinueReason is required.";
      isValid = false;
    }

    if (
      formData?.controlPurchaseNew &&
      vRdxUserCd?.UserGroupCode === "01" &&
      formData?.flagControlPurchase === 0 &&
      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val !== "N" &&
      (formData?.CNTRLPURReason == "" ||
        formData?.CNTRLPURReason == undefined ||
        formData?.CNTRLPURReason === null)
    ) {
      newError.CNTRLPURReason = "CNTRLPURReason is required.";
      isValid = false;
    }

    if (
      formData?.localPurchaseNew &&
      vRdxUserCd?.UserGroupCode === "01" &&
      formData?.flagLocalPurchase === 0 &&
      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val !== "N" &&
      (formData?.LCLPurReason == "" ||
        formData?.LCLPurReason == undefined ||
        formData?.LCLPurReason === null)
    ) {
      newError.LCLPurReason = "LCLPurReason is required.";
      isValid = false;
    }

    if (
      formData?.listingNew &&
      vRdxUserCd?.UserGroupCode === "01" &&
      formData?.flagListing === 0 &&
      (formData?.ListingReason == "" ||
        formData?.ListingReason == undefined ||
        formData?.ListingReason === null)
    ) {
      newError.ListingReason = "ListingReason is required.";
      isValid = false;
    }

    if (
      Number(formData?.moqNew) !== Number(formData?.moqOld) &&
      vRdxUserCd?.UserGroupCode === "01" &&
      formData?.flagMoq === 0 &&
      (formData?.MoqReason == "" ||
        formData?.MoqReason == undefined ||
        formData?.MoqReason === null)
    ) {
      newError.MoqReason = "MoqReason is required.";
      isValid = false;
    }

    if (
      (Number(formData?.minShelfQtyNew) !== Number(formData?.minShelfQtyOld) ||
        Number(formData?.maxShelfQtyNew) !==
          Number(formData?.maxShelfQtyOld)) &&
      vRdxUserCd?.UserGroupCode === "01" &&
      formData?.flagMinShelfQty === 0 &&
      (formData?.shelfqtyreason == "" ||
        formData?.shelfqtyreason == undefined ||
        formData?.shelfqtyreason === null)
    ) {
      newError.shelfqtyreason = "shelfqtyreason is required.";
      isValid = false;
    }

    if (
      (Number(formData?.minStockDaysNew) !==
        Number(formData?.minStockDaysOld) ||
        Number(formData?.safetyStockDaysNew) !==
          Number(formData?.safetyStockDaysOld)) &&
      vRdxUserCd?.UserGroupCode === "01" &&
      formData?.flagMinStockDays === 0 &&
      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val !== "N" &&
      (formData?.stockdaysreason == "" ||
        formData?.stockdaysreason == undefined ||
        formData?.stockdaysreason === null)
    ) {
      newError.stockdaysreason = "stockdaysreason is required.";
      isValid = false;
    }

    setErrors((prevError) => ({
      ...prevError,
      ...newError,
    }));

    if (!isValid) {
      const firstInvalidField = Object.keys(newError).find(
        (key) => newError[key]
      );
      document.querySelector(`[name="${firstInvalidField}"]`)?.focus();
    }

    return isValid;
  };

  const handleCheckboxChange = (field, e) => {
    const newValue = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      [field]: newValue,
    }));
  };

  const handleSelectFieldChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const fCalculateMaxStockDays = (minStockDays, safetyStockDays) => {
    return (minStockDays || 0) + (safetyStockDays || 0); // Calculate maxStockDaysNew
  };

  const handleChange = (field, value) => {
    setFormData((prev) => {
      // Convert the value to a number before updating state
      const newValue = Number(value) || 0;
      const newState = {
        ...prev,
        [field]: newValue, // Update the specific field with the numeric value
      };

      // Only recalculate maxStockDaysNew if the field being updated is minStockDaysNew or safetyStockDaysNew
      if (field === "minStockDaysNew" || field === "safetyStockDaysNew") {
        newState.maxStockDaysNew = fCalculateMaxStockDays(
          newState.minStockDaysNew,
          newState.safetyStockDaysNew
        );
      }

      return newState;
    });
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setFormData((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };
  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setFormData((obj) => ({
        ...obj,
        [e.target.name]: 0,
      }));
    }
  };

  const fStockSetupGetrow = async (
    vendorCd = vendorCd,
    locCd = loc,
    itmCd = ItemCd
  ) => {
    let iObj = {
      txtVendorCd: vendorCd,
      txtLocCd: locCd,
      txtItmCd: itmCd,
      isAdmin: true,
    };
    let vRespi = await INV05_StockSetupGetrow_Api(iObj);

    if (vRespi?.status === 200) {
      const stockData = vRespi?.data?.ResultSet;
      setFormData(stockData);

      // Update formData state with fetched data
      setFormData((prev) => {
        const updatedData = {
          ...prev,
          minStockDaysNew: stockData.minStockDaysNew || 0,
          safetyStockDaysNew: stockData.safetyStockDaysNew || 0,
        };

        // Calculate the maxStockDaysNew value
        updatedData.maxStockDaysNew = fCalculateMaxStockDays(
          updatedData.minStockDaysNew,
          updatedData.safetyStockDaysNew
        );

        return updatedData;
      });
    } else {
      return {};
    }
  };
  console.log("setFormData,", formData);

  const loadBarcodeList = async (ItmCd) => {
    if (ItmCd === "") {
      fAlertToast("FAILED", "Item Code should not be empty");
      return;
    }

    const obj = {
      ItmCd: ItmCd,
    };

    const response = await VNDRDISB_Barcode_List_Getrow(obj);

    if (response?.status === 200) {
      if (response?.data?.ResultSet.length > 0) {
        setBarcode(response?.data?.ResultSet);

        // Set the first barcode CD in formData.Barcode
        setFormData((prev) => ({
          ...prev,
          Barcode: response?.data?.ResultSet[0]?.Cd,
        }));
      }
      return response?.data?.ResultSet;
    } else {
      return [];
    }
  };

  const fReasonGetrowApi = async () => {
    const response = await StockSetupReason_GETROW();

    if (response?.status === 200) {
      const vRes = response?.data?.ResultSet;
      if (vRes && Object.keys(vRes).length > 0) {
        setDisReason(vRes.Discontinue);
        setActiveReason(vRes.Active);
        setDcDisconReason(vRes.DcDiscon);
        setCNTLReason(vRes.CNTLPurchase);
        setLocalPurReason(vRes.LocalPur);
        setVendorDisPurReason(vRes.VendorDis);
        setListedReason(vRes.Listed);
        setStockDaysReason(vRes.StockDays);
        setShelfQtyReason(vRes.ShelfQty);
        setMOQReason(vRes.MOQ);
      }
      return vRes;
    } else {
      return [];
    }
  };

  const fStockSetupUpdate = async () => {
    let iObj = {
      txtItmCd: ItemCd,
      txtLocCd: loc,
      txtVendorCd: vendorCd,
      pUserCd: vRdxUserCd.UserID,

      chkVendorDiscontinueOld: formData.vendorDiscontinueOld,
      chkVendorDiscontinueNew: formData.vendorDiscontinueNew,
      VendorReason: formData.VendorReason,

      chkDiscontinueOld: formData.discontinueOld,
      chkDiscontinueNew: formData.discontinueNew,
      DiscontinueReason: formData.DisContinuedReason,

      txtMinShelfQtyOld: formData.minShelfQtyOld,
      txtMinShelfQtyNew: formData.minShelfQtyNew,
      txtMaxShelfQtyOld: formData.maxShelfQtyOld,
      txtMaxShelfQtyNew: formData.maxShelfQtyNew,
      shelfQtyReason: formData.shelfqtyreason,

      txtMinStockDaysOld: formData.minStockDaysOld,
      txtMinStockDaysNew: formData.maxStockDaysNew,
      txtSafetyStockDaysOld: formData.safetyStockDaysOld,
      txtSafetyStockDaysNew: formData.safetyStockDaysNew,
      txtMaxStockDaysOld: formData.maxStockDaysOld,
      txtMaxStockDaysNew: formData.maxStockDaysNew,
      StockDaysReason: formData.stockdaysreason,

      chkLclPurOld: formData.localPurchaseOld,
      chkLclPurNew: formData.localPurchaseNew,
      LCLPurReason: formData.LCLPurReason,

      chkcntrlpurOld: formData.controlPurchaseOld,
      chkcntrlpurNew: formData.controlPurchaseNew,
      CNTRLPURReason: formData.CNTRLPURReason,

      chkDcDisContinueOld: formData.dcDiscontinueOld,
      chkDcDisContinueNew: formData.dcDiscontinueNew,
      DCDisContinueReason: formData.dcDiscontinueReason,

      chkIsActiveOld: formData.isActiveOld,
      chkIsActiveNew: formData.isActiveNew,
      ActiveReason: formData.ActiveReason,

      chkListedOld: formData.listingOld,
      chkListedNew: formData.listingNew,
      ListedReason: formData.ListingReason,

      txtMoqOld: formData.moqOld,
      txtMoqNew: formData.moqNew,
      MoqReason: formData.MoqReason,
      cmbBarcode: formData.Barcode,
    };

    let vRespi = await INV05_StockSetupUpdate_Api(iObj);
    if (vRespi.status === 200) {
      fAlertToast("SUCCESS", "Transaction details saved successfully");
    } else {
      fAlertToast(
        "FAILED",
        vRespi.response.data.message.msg || "error in save api"
      );
    }
    fStockSetupGetrow(vendorCd, loc, ItemCd, fCalculateMaxStockDays);
  };

  const fSave = async () => {
    setErrors(initialError);

    const isHeadValid = fValidation();
    if (!isHeadValid) return;
    confirmAlert({
      title: "Delete",
      message: "Are you want to Save?",
      buttons: [
        {
          className: "alertBtn",
          name: "DeletYes",
          label: "Yes",
          onClick: () => {
            fStockSetupUpdate();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };

  const fClose = () => {
    setFormData(initialFormData);
    setErrors(initialError);
    handleClose();
  };

  useEffect(() => {
    if (open) {
      fStockSetupGetrow(vendorCd, loc, ItemCd, fCalculateMaxStockDays);
      loadBarcodeList(ItemCd);
      fReasonGetrowApi();
    }
  }, [open]);

  useEffect(() => {
    if (open && vRdxuserLoc?.length) {
      const found = vRdxuserLoc.find((l) => l.UId === loc);
      console.log("found", found);

      if (found) {
        setLocationName(found.Name1);
      }
    }
  }, [open, loc, vRdxuserLoc]);
  console.log("vRdxuserLoc", vRdxuserLoc);

  return (
    <Modal open={open} onClose={fClose}>
      <Box sx={style}>
        <Box className="GCActiveItem-head" sx={{ flexShrink: 0 }}>
          <Typography variant="h6" sx={{ marginTop: 0.4 }}>
            Stock Setup Change - Request
          </Typography>
          <IconButton size="small" onClick={fClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <div style={{ height: "83vh", overflowY: "auto" }}>
          <Box sx={{ p:xMediaQuery?1: aMediaQuery ? 2 : 3 }} className="GCActiveItem">
            <Grid container spacing={1} justifyContent={"center"}>
              <Grid item xs={1.5}>
                <CmpTypographyNew xText={"Vendor"} />
              </Grid>
              <Grid item xs={0.5}>
                <CmpTypographyNew xText={":"} />
              </Grid>
              <Grid item xs={10}>
                <CmpTypographyNew xText={vendorCd + " - " + vendorName} />
              </Grid>
              <Grid item xs={1.5}>
                <CmpTypographyNew xText={"Location"} />
              </Grid>
              <Grid item xs={0.5}>
                <CmpTypographyNew xText={":"} />
              </Grid>
              <Grid item xs={10}>
                <CmpTypographyNew xText={loc + " - " + locationName} />
              </Grid>
              <Grid item xs={1.5}>
                <CmpTypographyNew xText={"Item"} />
              </Grid>
              <Grid item xs={0.5}>
                <CmpTypographyNew xText={":"} />
              </Grid>
              <Grid item xs={10}>
                <CmpTypographyNew xText={ItemCd + " - " + ItemName} />
              </Grid>
            </Grid>

            <Grid
              container
              spacing={aMediaQuery ? 0.5 : 1}
              sx={{
                mt: 3,
                paddingX: vMediaQuery ? 0 : aMediaQuery ? 2 : 4,
              }}
            >
              <Grid item xs={3}  pb={1}></Grid>
              <Grid item xs={2} pb={1}>
                <Typography align="center" fontWeight={600}>
                  OLD
                </Typography>
              </Grid>
              <Grid item xs={2} pb={1}>
                <Typography align="center" fontWeight={600}>
                  NEW
                </Typography>
              </Grid>
              <Grid item align="center" fontWeight={600} xs={xMediaQuery?5:3} pb={1}>
                REASON
              </Grid>
              <>

                <Grid item xs={3} md={3} paddingLeft={2}>
                  <CmpTypographyField xText={"Discontinue"} />
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox checked={formData.discontinueOld} disabled />
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox
                    checked={formData.discontinueNew}
                    onChange={(e) => handleCheckboxChange("discontinueNew", e)}
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagDiscontinue != 0
                    }
                  />
                </Grid>
                <Grid item xs={xMediaQuery?5:3} mt={0.5}>
                  <CmpSelectField
                    xValue={formData.DisContinuedReason}
                    xOnChange={handleSelectFieldChange}
                    xName={"DisContinuedReason"}
                    xData={disReason}
                    xValueMember={"UId"}
                    xDispalyMember={"Name1"}
                    xError={errors.DisContinuedReason === "" ? false : true}
                    xErrorMessage={errors.DisContinuedReason}
                    xDisable={false}
                  />
                </Grid>


                <Grid item xs={3} paddingLeft={2}>
                  <CmpTypographyField xText={"IsActive"} />
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox checked={formData.isActiveOld} disabled />
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox
                    checked={formData.isActiveNew}
                    onChange={(e) => handleCheckboxChange("isActiveNew", e)}
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagActive != 0
                    }
                  />
                </Grid>
                <Grid item xs={xMediaQuery?5:3} mt={0.5}>
                  <CmpSelectField
                    xValue={formData.ActiveReason}
                    xOnChange={handleSelectFieldChange}
                    xName={"ActiveReason"}
                    xData={activeReason}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={errors.ActiveReason === "" ? false : true}
                    xErrorMessage={errors.ActiveReason}
                    xDisable={false}
                  />
                </Grid>

                <Grid
                  item
                  xs={3}
                  paddingLeft={2}
                  sx={{ color: "red !important", fontWeight: 800 }}
                >
                  <Typography
                    color={
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                        ? "grey"
                        : "primary"
                    }
                  >
                    Dc Discontinue
                  </Typography>
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox checed={formData.dcDiscontinueOld} disabled />
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox
                    checked={formData.dcDiscontinueNew}
                    onChange={(e) =>
                      handleCheckboxChange("dcDiscontinueNew", e)
                    }
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagDCDiscontinue != 0 ||
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                    }
                  />
                </Grid>
                <Grid item xs={xMediaQuery?5:3} mt={0.5}>
                  <CmpSelectField
                    xValue={formData.dcDiscontinueReason}
                    xOnChange={handleSelectFieldChange}
                    xName={"dcDiscontinueReason"}
                    xData={dcDisconReason}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={errors.dcDiscontinueReason === "" ? false : true}
                    xErrorMessage={errors.dcDiscontinueReason}
                    xDisable={false}
                  />
                </Grid>

                <Grid item xs={3} paddingLeft={2}>
                  <Typography
                    color={
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                        ? "grey"
                        : "primary"
                    }
                  >
                    Central Purchase
                  </Typography>
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox checked={formData.controlPurchaseOld} disabled />
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox
                    checked={formData.controlPurchaseNew}
                    onChange={(e) =>
                      handleCheckboxChange("controlPurchaseNew", e)
                    }
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagControlPurchase != 0 ||
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                    }
                  />
                </Grid>
                <Grid item xs={xMediaQuery?5:3} mt={0.5}>
                  <CmpSelectField
                    xValue={formData.CNTRLPURReason}
                    xOnChange={handleSelectFieldChange}
                    xName={"CNTRLPURReason"}
                    xData={cNTLPurchaseReason}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={errors.CNTRLPURReason === "" ? false : true}
                    xErrorMessage={errors.CNTRLPURReason}
                    xDisable={false}
                  />
                </Grid>

                <Grid item xs={3} paddingLeft={2}>
                  <Typography
                    color={
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                        ? "grey"
                        : "primary"
                    }
                  >
                    Allow Local Purchase
                  </Typography>
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox checked={formData.localPurchaseOld} disabled />
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox
                    checked={formData.localPurchaseNew}
                    onChange={(e) =>
                      handleCheckboxChange("localPurchaseNew", e)
                    }
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagLocalPurchase != 0 ||
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                    }
                  />
                </Grid>
                <Grid item xs={xMediaQuery?5:3} mt={0.5}>
                  <CmpSelectField
                    xValue={formData.LCLPurReason}
                    xOnChange={handleSelectFieldChange}
                    xName={"LCLPurReason"}
                    xData={localPurReason}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={errors.LCLPurReason === "" ? false : true}
                    xErrorMessage={errors.LCLPurReason}
                    xDisable={false}
                  />
                </Grid>

                <Grid item xs={3} paddingLeft={2}>
                  <CmpTypographyField xText={"Vendor Discontinue"} />
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox checked={formData.vendorDiscontinueOld} disabled />
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox
                    checked={formData.vendorDiscontinueNew}
                    onChange={(e) =>
                      handleCheckboxChange("vendorDiscontinueNew", e)
                    }
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagVendorDiscontinue != 0
                    }
                  />
                </Grid>
                <Grid item xs={3} mt={0.5} className="GCItemBarcode">
                  <CmpSelectField
                    xValue={formData.Barcode}
                    xOnChange={handleSelectFieldChange}
                    xName={"Barcode"}
                    xData={barcode}
                    xValueMember={"Cd"}
                    xDispalyMember={"BarcodeDetails"}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={formData.vendorDiscontinueNew === false}
                  />
                </Grid>
                <Grid item xs={2} mt={0.5}>
                  <CmpSelectField
                    xValue={formData.VendorReason}
                    xOnChange={handleSelectFieldChange}
                    xName={"VendorReason"}
                    xData={vendorDisReason}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={errors.VendorReason === "" ? false : true}
                    xErrorMessage={errors.VendorReason}
                    xDisable={false}
                  />
                </Grid>

                <Grid item xs={3} paddingLeft={2}>
                  <CmpTypographyField xText={"Listed"} />
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox checked={formData.listingOld} disabled />
                </Grid>
                <Grid item xs={2} align="center">
                  <Checkbox
                    checked={formData.listingNew}
                    onChange={(e) => handleCheckboxChange("listingNew", e)}
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagListing != 0
                    }
                  />
                </Grid>
                <Grid item xs={xMediaQuery?5:3} mt={0.5}>
                  <CmpSelectField
                    xValue={formData.ListingReason}
                    xOnChange={handleSelectFieldChange}
                    xName={"ListingReason"}
                    xData={listedReason}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={errors.ListingReason === "" ? false : true}
                    xErrorMessage={errors.ListingReason}
                    xDisable={false}
                  />
                </Grid>

              </>
              {/* TextFileds */}
              <>
                <Grid item xs={3} paddingLeft={2} mt={2}>
                  <Typography
                    color={
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                        ? "grey"
                        : "primary"
                    }
                  >
                    Min Stock Days
                  </Typography>
                </Grid>
                <Grid item xs={2} align="center" mt={2}>
                  <TextField
                    size="small"
                    type="number"
                    value={formData.minStockDaysOld}
                    variant="filled"
                    sx={{
                     width:xMediaQuery?'100%': "50%",
                    }}
                    disabled
                  />
                </Grid>
                <Grid item xs={2} align="center" mt={2}>
                  <TextField
                    size="small"
                    // type="number"
                    name="minStockDaysNew"
                    autoComplete="off"
                    value={formData.minStockDaysNew}
                    sx={{
                     width:xMediaQuery?'100%': "50%",
                    }}
                    onChange={(e) =>
                      handleChange("minStockDaysNew", e.target.value)
                    }
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "safetyStockDaysNew");
                    }}
                    onFocus={fContent_Focus}
                    onBlur={fContent_Blur}
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagMinStockDays != 0 ||
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                    }
                    variant={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagMinStockDays != 0 ||
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                        ? "filled"
                        : "outlined"
                    }
                  />
                </Grid>
                <Grid item xs={5} align="center" mt={2}></Grid>

                <Grid item xs={3} paddingLeft={2}>
                  <Typography
                    color={
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                        ? "grey"
                        : "primary"
                    }
                  >
                    Safety Stock Days
                  </Typography>
                </Grid>
                <Grid item xs={2} align="center">
                  <TextField
                    size="small"
                    type="number"
                    variant="filled"
                    value={formData.safetyStockDaysOld}
                    sx={{
                     width:xMediaQuery?'100%': "50%",
                    }}
                    disabled
                  />
                </Grid>
                <Grid item xs={2} align="center">
                  <TextField
                    size="small"
                    name="safetyStockDaysNew"
                    value={formData.safetyStockDaysNew}
                    sx={{
                     width:xMediaQuery?'100%': "50%",
                    }}
                    onChange={(e) =>
                      handleChange("safetyStockDaysNew", e.target.value)
                    }
                    autoComplete="off"
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "maxShelfQtyNew");
                    }}
                    onFocus={fContent_Focus}
                    onBlur={fContent_Blur}
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagSafetyStockDays != 0 ||
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                    }
                    variant={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagSafetyStockDays != 0 ||
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                        ? "filled"
                        : "outlined"
                    }
                  />
                </Grid>
                <Grid item xs={xMediaQuery?5:3} mt={0.5}>
                  <CmpSelectField
                    xValue={formData.stockdaysreason}
                    xOnChange={handleSelectFieldChange}
                    xName={"stockdaysreason"}
                    xData={stockDaysReason}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={errors.stockdaysreason === "" ? false : true}
                    xErrorMessage={errors.stockdaysreason}
                    xDisable={false}
                  />
                </Grid>

                <Grid item xs={3} paddingLeft={2}>
                  <Typography
                    color={
                      vRdxDBKernObj?.STOCK_SETUP_MAX_FIELD?.Val == "N"
                        ? "grey"
                        : "primary"
                    }
                  >
                    Max Stock Days
                  </Typography>
                </Grid>
                <Grid item xs={2} align="center">
                  <TextField
                    size="small"
                    type="number"
                    variant="filled"
                    value={formData.maxStockDaysOld}
                    sx={{
                     width:xMediaQuery?'100%': "50%",
                    }}
                    disabled
                  />
                </Grid>
                <Grid item xs={2} align="center">
                  <TextField
                    size="small"
                    type="number"
                    variant="filled"
                    value={formData.maxStockDaysNew}
                    sx={{
                     width:xMediaQuery?'100%': "50%",
                    }}
                    disabled
                  />
                </Grid>
                <Grid item xs={5} align="center"></Grid>

                <Grid item xs={3} paddingLeft={2}>
                  <CmpTypographyField xText={"Max Shelf Qty"} />
                </Grid>
                <Grid item xs={2} align="center">
                  <TextField
                    size="small"
                    type="number"
                    variant="filled"
                    value={formData.maxShelfQtyOld}
                    sx={{
                     width:xMediaQuery?'100%': "50%",
                    }}
                    disabled
                  />
                </Grid>
                <Grid item xs={2} align="center">
                  <TextField
                    size="small"
                    type="number"
                    value={formData.maxShelfQtyNew}
                    sx={{
                     width:xMediaQuery?'100%': "50%",
                    }}
                    name="maxShelfQtyNew"
                    onChange={(e) =>
                      handleChange("maxShelfQtyNew", e.target.value)
                    }
                    autoComplete="off"
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "minShelfQtyNew");
                    }}
                    onFocus={fContent_Focus}
                    onBlur={fContent_Blur}
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagMaxShelfQty != 0
                    }
                    variant={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagMaxShelfQty != 0
                        ? "filled"
                        : "outlined"
                    }
                  />
                </Grid>
                <Grid item xs={xMediaQuery?5:3} mt={0.5}>
                  <CmpSelectField
                    xValue={formData.shelfqtyreason}
                    xOnChange={handleSelectFieldChange}
                    xName={"shelfqtyreason"}
                    xData={shelfQtyReason}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={errors.shelfqtyreason === "" ? false : true}
                    xErrorMessage={errors.shelfqtyreason}
                    xDisable={false}
                  />
                </Grid>

                <Grid item xs={3} paddingLeft={2}>
                  <CmpTypographyField xText={"Min Shelf Days"} />
                </Grid>
                <Grid item xs={2} align="center">
                  <TextField
                    size="small"
                    type="number"
                    variant="filled"
                    value={formData.minShelfQtyOld}
                    sx={{
                     width:xMediaQuery?'100%': "50%",
                    }}
                    disabled
                  />
                </Grid>
                <Grid item xs={2} align="center">
                  <TextField
                    size="small"
                    // type="number"
                    name="minShelfQtyNew"
                    value={formData.minShelfQtyNew}
                    sx={{
                     width:xMediaQuery?'100%': "50%",
                    }}
                    onChange={(e) =>
                      handleChange("minShelfQtyNew", e.target.value)
                    }
                    onKeyUp={(e) => {
                      fKeyTabInput(e, "moqNew");
                    }}
                    onFocus={fContent_Focus}
                    onBlur={fContent_Blur}
                    autoComplete="off"
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagMinShelfQty != 0
                    }
                    variant={
                      vRdxUserCd?.UserGroupCode != "01" ||
                      formData.flagMinShelfQty != 0
                        ? "filled"
                        : "outlined"
                    }
                  />
                </Grid>
                <Grid item xs={5} align="center"></Grid>

                <Grid item xs={3} paddingLeft={2}>
                  <CmpTypographyField xText={"MOQ"} />
                </Grid>
                <Grid item xs={2} align="center">
                  <TextField
                    size="small"
                    type="number"
                    variant="filled"
                    value={formData.moqOld}
                    sx={{
                     width:xMediaQuery?'100%': "50%",
                    }}
                    disabled
                  />
                </Grid>
                <Grid item xs={2} align="center">
                  <TextField
                    size="small"
                    // type="number"
                    name="moqNew"
                    value={formData.moqNew}
                    sx={{
                      width:xMediaQuery?'100%': "50%",
                    }}
                    onChange={(e) => handleChange("moqNew", e.target.value)}
                    onFocus={fContent_Focus}
                    onBlur={fContent_Blur}
                    autoComplete="off"
                    disabled={
                      vRdxUserCd?.UserGroupCode != "01" || formData.flagMoq != 0
                    }
                    variant={
                      vRdxUserCd?.UserGroupCode != "01" || formData.flagMoq != 0
                        ? "filled"
                        : "outlined"
                    }
                  />
                </Grid>
                <Grid item xs={xMediaQuery?5:3} mt={0.5}>
                  <CmpSelectField
                    xValue={formData.MoqReason}
                    xOnChange={handleSelectFieldChange}
                    xName={"MoqReason"}
                    xData={moqReason}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={errors.MoqReason === "" ? false : true}
                    xErrorMessage={errors.MoqReason}
                    xDisable={false}
                  />
                </Grid>
              </>
            </Grid>

            <Box mt={3} textAlign="center">
              <CmpButton xbtnName="Save" xOnClick={fSave} />
            </Box>
          </Box>
        </div>
      </Box>
    </Modal>
  );
}
